import React from 'react';

import Header from '../../layout/Header.jsx';
import ListAds from '../../lists/ListAds.jsx';

const PageAdsList = () => (
  <div>
    <Header>Banners</Header>
    <ListAds />
  </div>
);

export default PageAdsList;
